import $ from "jquery";
import _ from "underscore";
import { Application } from "./application/Application";
import "../styles/index.less"

$(document).ready(() => {
    var [route, params] = window.location.hash.slice(1).split("?");
    var env; // = window.location.hostname.substr(-7) == "xola.tv" ? "production" : "dev";
    switch (window.location.hostname) {
        case "xola.tv":
        case "www.xola.tv":
            env = "production";
            break;

        case "sandbox.xola.tv":
            env = "sandbox";
            break;

        case "x2.xola.tv":
            env = "x2";
            break;

        case "x2.sandbox.xola.tv":
            env = "sandbox.x2";
            break;

        case "x2.staging.xola.tv":
            env = "staging.x2";
            break;

        default:
            env = "dev";
    }
    var options = {
        env: env,
        redirect: true,
        debug: false
    };

    if (params) {
        _.each(params.split("&"), (fragment) => {
            var [name, value] = fragment.split("=");

            // Parse params
            switch (name) {
                case "redirect":
                    value = value == "true";
                    break;
            }

            options[name] = value;
        });

        if (options.redirect) {
            window.history.pushState({}, "Xola", window.location.pathname + "#" + route);
        }
    }

    if (options.env == "dev") {
        options.debug = true;
    }

    if (!options.baseUrl) {
        options.baseUrl = window.location.origin;
    }

    var app = new Application(options);
    app.start();
});



// WEBPACK FOOTER //
// ./src/js/index.js